import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";
import { ContentBlockData, getContentBlockSchema } from "./";

export interface PageEditData {
    id: number;
    active: boolean;
    contentBlocks: ContentBlockData[];
    hasHero: boolean;
    hasFeaturedPages: boolean;
    title: string;
}

export class PageEdit implements FormValidationModel<PageEditData> {
    public data: PageEditData;
    public rules: yup.Schema<PageEditData>;

    public constructor() {
        this.data = {
            id: 0,
            active: true,
            contentBlocks: [],
            hasHero: false,
            hasFeaturedPages: false,
            title: "",
        };
        this.rules = yup.object<PageEditData>().shape({
            id: yup.number().required().label("ID").min(0, "Invalid ID"),
            active: yup.bool(),
            contentBlocks: yup.array().of(getContentBlockSchema),
            hasHero: yup.bool().label("Include page hero"),
            hasFeaturedPages: yup.bool().label("Include featured pages list"),
            title: yup.string().required().max(250).label("Title"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminPage/PageEdit.ts